import { Component, Input } from '@angular/core';
import { AtAGlanceNotification } from '@models';

interface NotificationStatusIcon {
  name: string;
  color: string;
  width: string;
  height: string;
}

const STATUS_ICON_DEFAULT: NotificationStatusIcon = {
  name: 'warning-bold',
  color: '#F56A00',
  width: '14px',
  height: '12px'
};

const STATUS_ICON_MAP: Record<string, NotificationStatusIcon> = {
  upcoming: {
    name: 'arrow-right-circle',
    color: '#D9D9D9',
    width: '14px',
    height: '14px'
  },
  'past due': {
    name: 'exclamation-circle-bold',
    color: '#B60150',
    width: '14px',
    height: '14px'
  },
  'off track': {
    name: 'exclamation-circle-bold',
    color: '#B60150',
    width: '14px',
    height: '14px'
  },
  'off target': {
    name: 'exclamation-circle-bold',
    color: '#B60150',
    width: '14px',
    height: '14px'
  },
  critical: {
    name: 'exclamation-circle-bold',
    color: '#B60150',
    width: '14px',
    height: '14px'
  },
  'at risk': {
    name: 'warning-bold',
    color: '#F56A00',
    width: '14px',
    height: '14px'
  },
  major: {
    name: 'warning-bold',
    color: '#F56A00',
    width: '14px',
    height: '14px'
  },
  'on track': {
    name: 'like',
    color: '#01891E',
    width: '14px',
    height: '14px'
  }
};

function normalizeStatus(status: string): string {
  return status.trim().toLowerCase();
}

function getStatusIcon(status: string): NotificationStatusIcon {
  return STATUS_ICON_MAP[normalizeStatus(status)] ?? STATUS_ICON_DEFAULT;
}

@Component({
  selector: 'notification-card',
  templateUrl: './notification-card.component.html',
  styleUrls: ['./notification-card.component.scss']
})
export class NotificationCardComponent {
  @Input() showClientName = false;
  @Input({ required: true }) item!: AtAGlanceNotification;

  get statusIcon(): NotificationStatusIcon {
    return getStatusIcon(this.item.status);
  }
}

export type { AtAGlanceNotification, NotificationStatusIcon };
